import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { DialogContent } from 'Views/Page/Content/Modal/Components';

const Layout = () => {
  const { onSubmit } = useMetaLayoutContext();

  return (
    <>
      <MetaControlField attr="title" />
      <DialogContent>
        <MetaControlField attr="incomeType" onInlineSubmit={onSubmit} />
      </DialogContent>
    </>
  );
};

export default Layout;
